import React from 'react';
import PropTypes from 'prop-types';
import AppContext from 'src/AppContext';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import NavMobileLink from '../NavMobileLink/NavMobileLink';
import './NavMobileProfileMenu.css';


const NavMobileProfileMenu = ({
  onNavigate,
  Region,
  UserName,
  handleLogout,
  hasManageAccess,
  hasLoginAsAdmin,
}) => {
  const { REGION_CONTACT_EMAIL } = useSelector(state => state.appConfig);

  return (
    <div className="nav-mobile-profile-menu">
      <div className="nav-mobile-profile-menu__welcome">
        <div>{i18n.t('dash:Welcome')}</div>
        <div>{UserName}</div>
        <div>{Region}</div>
      </div>
      <ul className="nav-mobile-profile-menu__list">
        <NavMobileLink onClick={onNavigate} to="/custom-reports" icon="insert_drive_file" title={i18n.t('dash:Custom Reports')} />
        <NavMobileLink onClick={onNavigate} to="/resources" icon="image" title={i18n.t('dash:Resources')} />
        <NavMobileLink onClick={onNavigate} to="/my-account" icon="person" title={i18n.t('dash:My Account')} />
        <NavMobileLink onClick={onNavigate} to="/email-notifications" icon="mail" title={i18n.t('dash:Email Notifications')} />
        {
          hasManageAccess &&
          <NavMobileLink onClick={onNavigate} to="/manage-access" icon="lock" title={i18n.t('dash:Manage Access')} />
        }
        {
          hasLoginAsAdmin &&
          <NavMobileLink onClick={onNavigate} to="/admin" icon="supervised_user_circle" title={i18n.t('dash:Login as Admin')} />
        }
        <NavMobileLink onClick={(e, to) => { window.location.href = to; }} to={`mailto:${REGION_CONTACT_EMAIL}`}icon="contact_mail" title={i18n.t('nav:Contact Us')} />
        <NavMobileLink onClick={onNavigate} to="/privacy" icon="insert_drive_file" title={i18n.t('footer:Privacy')} />
        <NavMobileLink onClick={onNavigate} to="/terms" icon="insert_drive_file" title={i18n.t('footer:Terms and Conditions')} />
        <NavMobileLink onClick={handleLogout} to="/logout" icon="exit_to_app" title={i18n.t('dash:Logout')} />
      </ul>
    </div>
  );
};

NavMobileProfileMenu.propTypes = {
  onNavigate: PropTypes.func,
  handleLogout: PropTypes.func,
  UserName: PropTypes.string,
  Region: PropTypes.string,
  hasManageAccess: PropTypes.bool,
  hasLoginAsAdmin: PropTypes.bool,
};

export default (props => (
  <AppContext.Consumer>
    {context => (
      <NavMobileProfileMenu
        {...props}
        setAppState={context.setAppState}
      />
    )}
  </AppContext.Consumer>
));



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobileProfileMenu/NavMobileProfileMenu.jsx